<template>
  <div class="mainbody" style="min-height: 40vw;">
   
    <div class="containerDiv"> 
      

      <div class="whiteBg" > 
        <div class="txtMd21" > 
          <div v-html="brief.content"></div>
         
        </div>
        <div class="imgMd2"> 
          <!-- <img src="../../assets/img3/yewubankuai1/2.jpg" /> -->
          <img src="../../assets/img3/yewubankuai1/2New.jpg" />
        </div>
      </div>
 
      <div class="modules3Container"> 
        <div class="modules3Div" v-scroll-animate="'fly-in-right5'"> 
          <div class="modules3rowDiv">
              
                <div class="modules3Item" @mouseover="indexNum = index"
                                      @mouseleave="indexNum = null"
                                      @click="goA(index)"
                                    :class="(indexNum == index)?'activeYwbkItem2':''" v-for="(item,index) in segmentsList" :key="index">
                  <ul>
                    <li>
                      <img :src="urlBase+item.icon.split('|')[1]"  />
                    </li>
                    <li class="titleModule3item">
                      <a :href="'/detailPage1?index='+(index)" > {{ item.names }}  </a>
                    </li>
                  </ul>
                </div>

                <div class="modules3Item" @mouseover="indexNum = 7"
                                      @mouseleave="indexNum = null"
                                      @click="goA('00')"
                                    :class="(indexNum == 7)?'activeYwbkItem2':''"  >
                  <ul>
                    <li  >
                      <img src="../../assets/ywbkNew/1/detailCoin.png" />
                    </li>
                    <li class="titleModule3item">
                      <a href="/detailPage1">详情>></a>
                    </li>
                  </ul>
                </div>
               
          </div>

         
            <!-- <div class="goDetailDiv"  > <a href="/detailPage1">详情>></a> </div> -->
        </div>
      </div>

      <div class="modules3Container1"> 
        <div class="modules3Div1" v-scroll-animate="'fade-in5'"> 
           <h5>发展愿景</h5>
           <p v-html="brief.expand"></p>
           <!-- <p>
            物流集团几个业务板块联系人请都按照如下补充：
联系人：李女士，联系方式：15188351207
地址：郑州市经济技术开发区经开第十八大街与经北一路交叉口 郑州国际陆港汽车口岸C座
            
           </p> -->
        </div>
      </div>
    </div>
   </div>
</template>

<script>
// import Modules3 from '@/components/gk/Modules3.vue'
import API from '@/api/bsInfo'


export default {
 components: {
 },
 data() {
   return {
    urlBase: process.env.VUE_APP_BASE_API,
    brief:{},
    segmentsList:[],
   indexNum:null,
   indexNum1:null,
  //  datalist1:[
  //   {
  //     name:'国际货运代理服务'
  //   },
  //   {
  //     name:'多式联运运营服务'
  //   },
  //   {
  //     name:'国外物流业务服务'
  //   },
  //   {
  //     name:'物流技术装备服务'
  //   }
  //  ],
  //  datalist2:[
  //   {
  //     name:'供应链综合服务'
  //   },
  //   {
  //     name:'仓储配送一体化服务'
  //   },
  //   {
  //     name:'冷链物流服务'
  //   },
  //   {
  //     name:'运贸融合发展服务'
  //   }
  //  ]
    
     
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
   },
 methods: {
   //获取页面数据
   async zhongoubanlieData() {
      try {
        let objParams={
          catId:'d3763ecc99d14860934e4fdc09c8c997'
        }
        const res = await API.zhongoubanlieData(objParams)
        this.$nextTick(()=>{
          this.zhongouData = res.data
          this.brief=res.data.brief
          this.segmentsList=res.data.segmentsList
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },

  goA(indexNum){
    if(indexNum !== '00'){
      window.location.href='/detailPage1?index='+indexNum

    }else{
      window.location.href='/detailPage1'

    }
  }
 },
}
</script>

<style lang="scss" scoped>

 .mainbody{
   width: 100%
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }

 .whiteBg{
   width:90vw;
   margin:0 auto;
   height: 21vw;
  //  margin-bottom: 5rem;
  //  padding:2rem 0;
  //  background:url('../../assets/img3/yewubankuai1/2.png') no-repeat;
    // background-size: auto 100%;
    // background-position: right;
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  display: flex;
  @media screen and (max-width: 768px) {
    display: block;
    }
  .txtMd21{
    width: 50vw;
     height: 21vw !important;
    padding-left: 5%;
    padding-right: 3rem;
    // padding:2rem 5rem;
    // padding-right: 1rem;
    font-size: 1.1rem;
    line-height: 2rem;
    text-indent:2rem;
    text-align: justify;
    color: #ffffff;
    background-color:#015293;  

    display: grid;
    place-items: center; /* 水平 + 垂直居中 */
     
    @media screen and (max-width: 768px) {
      width: 100%;
      // color:red;
       height: auto !important;
      margin-left:0;
      line-height: 2rem;
    }

      /* 重置所有子元素 */
      & * {
      all: initial;
      font-family: inherit;
      font-size: inherit;
      color: inherit;

     
      text-indent:2rem;
      text-align: justify;
      line-height: 2rem;
    }
    div{
      align-items: center;
      // background: red;
    
    }
    
  }

  .txtMd21 ::v-deep(*) {
    font-size:1rem !important;
    line-height: 2rem !important;
  }
  .txtMd21 ::v-deep(p) {
     width: 100%;
     display: block;

    //  background: red;
  }
  .imgMd2{
    width:40vw;
    height: 21vw !important;
    img{
      width: 100%;
      height: 21vw !important;
      // object-fit: cover;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      height: auto !important;
      img{
         height: auto !important;
      }
    }
  }
 } 
 .modules3Container{


  position: relative;
  width: 100%;
  @media screen and (max-width: 768px) {
      margin-top:30rem;
    }
  .modules3Item{
 
  color: #333333;
 }

 }
 .modules3Container1{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;
  margin-top: 2rem;
  position: relative;
  width: 100%;
  padding-bottom: 12.25%; /* 16:9 比例 (9/16=0.5625) */
  background:url('../../assets/img3/yewubankuai1/3.jpg');
  background-size: cover;
  background-position: center;

 }
 .modules3Div{
   width: 90vw;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
 }
 .modules3rowDiv{
  // padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #015293;

  
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
    a{
      color: #ffffff;
    }
   }
   li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   }
 }
 .modules3Div1{
  width: 65%;
  padding-left: 5%;
  color: #ffffff;
  // background: #ffffff;
  h5{
    font-size: 1.5rem;
    padding:2rem 0;
  }
  p{
    font-size: 1.2rem;
    width: 90vw;
    line-height: 2.8rem;
  }
 }
 .goDetailDiv{
  text-align: center;
  a{
    color: #015293;

  }
}
 </style>